import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=APPLE_BACKDROP_EXP:control
// ?preferred_variant=APPLE_BACKDROP_EXP:variant_1
// ?preferred_variant=APPLE_BACKDROP_EXP:variant_2
// ?remove_preferred_experiment=APPLE_BACKDROP_EXP

export const AppleBackdropExpName = 'APPLE_BACKDROP_EXP' as const;

export type AppleBackdropExpVariants = ToVariants<typeof AppleBackdropExpVariants>;

export const AppleBackdropExpVariants = {
	/** Dailymotion trailer behind play button */
	CONTROL: 'control',
	/** Deeplink to Apple TV / TV+ on all Apple TV / TV+ titles from play button */
	VARIANT_1: 'variant_1',
	/** Link to Apple TV+ on all titles from play button */
	VARIANT_2: 'variant_2',
} as const;

export default generate(AppleBackdropExpName, AppleBackdropExpVariants);
